/** Shared category color styles used by dashboard and product views. */
export const CATEGORY_COLORS: Record<string, { bg: string; text: string }> = {
  'Coffee': { bg: 'bg-[#4A2D5E]/10', text: 'text-[#4A2D5E]' },
  'Food': { bg: 'bg-[#2E6B4F]/10', text: 'text-[#2E6B4F]' },
  'Pastry': { bg: 'bg-[#B54A4A]/10', text: 'text-[#B54A4A]' },
  'Tea': { bg: 'bg-[#7BA68E]/20', text: 'text-[#2E6B4F]' },
};

export function getCategoryStyle(category: string) {
  return CATEGORY_COLORS[category] || { bg: 'bg-[#E6E2DE]', text: 'text-[#6B6670]' };
}
